/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Language_DaInputs */

const en_nav_language_da = /** @type {(inputs: Nav_Language_DaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dansk`)
};

const es_nav_language_da = /** @type {(inputs: Nav_Language_DaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dansk`)
};

const de_nav_language_da = /** @type {(inputs: Nav_Language_DaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dansk`)
};

const zh_nav_language_da = /** @type {(inputs: Nav_Language_DaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dansk`)
};

const ar_nav_language_da = /** @type {(inputs: Nav_Language_DaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dansk`)
};

const fr_nav_language_da = /** @type {(inputs: Nav_Language_DaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dansk`)
};

const vi_nav_language_da = /** @type {(inputs: Nav_Language_DaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dansk`)
};

const sw_nav_language_da = /** @type {(inputs: Nav_Language_DaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dansk`)
};

const th_nav_language_da = /** @type {(inputs: Nav_Language_DaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dansk`)
};

const bs_nav_language_da = /** @type {(inputs: Nav_Language_DaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dansk`)
};

const ja_nav_language_da = /** @type {(inputs: Nav_Language_DaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dansk`)
};

const ko_nav_language_da = /** @type {(inputs: Nav_Language_DaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dansk`)
};

const pt_nav_language_da = /** @type {(inputs: Nav_Language_DaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dansk`)
};

const it_nav_language_da = /** @type {(inputs: Nav_Language_DaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dansk`)
};

const sv_nav_language_da = /** @type {(inputs: Nav_Language_DaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dansk`)
};

const nl_nav_language_da = /** @type {(inputs: Nav_Language_DaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dansk`)
};

const da_nav_language_da = /** @type {(inputs: Nav_Language_DaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dansk`)
};

const nb_nav_language_da = /** @type {(inputs: Nav_Language_DaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dansk`)
};

const fi_nav_language_da = /** @type {(inputs: Nav_Language_DaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dansk`)
};

const pl_nav_language_da = /** @type {(inputs: Nav_Language_DaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dansk`)
};

const ru_nav_language_da = /** @type {(inputs: Nav_Language_DaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dansk`)
};

const tr_nav_language_da = /** @type {(inputs: Nav_Language_DaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dansk`)
};

const hi_nav_language_da = /** @type {(inputs: Nav_Language_DaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dansk`)
};

const id_nav_language_da = /** @type {(inputs: Nav_Language_DaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dansk`)
};

const ms_nav_language_da = /** @type {(inputs: Nav_Language_DaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dansk`)
};

const cs_nav_language_da = /** @type {(inputs: Nav_Language_DaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dansk`)
};

const el_nav_language_da = /** @type {(inputs: Nav_Language_DaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dansk`)
};

const he_nav_language_da = /** @type {(inputs: Nav_Language_DaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dansk`)
};

const af_nav_language_da = /** @type {(inputs: Nav_Language_DaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dansk`)
};

const hu_nav_language_da = /** @type {(inputs: Nav_Language_DaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dansk`)
};

/**
* | output |
* | --- |
* | "Dansk" |
*
* @param {Nav_Language_DaInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const nav_language_da = /** @type {((inputs?: Nav_Language_DaInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Language_DaInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_language_da(inputs)
	if (locale === "de") return de_nav_language_da(inputs)
	if (locale === "zh") return zh_nav_language_da(inputs)
	if (locale === "ar") return ar_nav_language_da(inputs)
	if (locale === "fr") return fr_nav_language_da(inputs)
	if (locale === "vi") return vi_nav_language_da(inputs)
	if (locale === "sw") return sw_nav_language_da(inputs)
	if (locale === "th") return th_nav_language_da(inputs)
	if (locale === "bs") return bs_nav_language_da(inputs)
	if (locale === "ja") return ja_nav_language_da(inputs)
	if (locale === "ko") return ko_nav_language_da(inputs)
	if (locale === "pt") return pt_nav_language_da(inputs)
	if (locale === "it") return it_nav_language_da(inputs)
	if (locale === "sv") return sv_nav_language_da(inputs)
	if (locale === "nl") return nl_nav_language_da(inputs)
	if (locale === "da") return da_nav_language_da(inputs)
	if (locale === "nb") return nb_nav_language_da(inputs)
	if (locale === "fi") return fi_nav_language_da(inputs)
	if (locale === "pl") return pl_nav_language_da(inputs)
	if (locale === "ru") return ru_nav_language_da(inputs)
	if (locale === "tr") return tr_nav_language_da(inputs)
	if (locale === "hi") return hi_nav_language_da(inputs)
	if (locale === "id") return id_nav_language_da(inputs)
	if (locale === "ms") return ms_nav_language_da(inputs)
	if (locale === "cs") return cs_nav_language_da(inputs)
	if (locale === "el") return el_nav_language_da(inputs)
	if (locale === "he") return he_nav_language_da(inputs)
	if (locale === "af") return af_nav_language_da(inputs)
	if (locale === "hu") return hu_nav_language_da(inputs)
	return en_nav_language_da(inputs)
});